// @ts-nocheck
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Link } from "@tanstack/react-router";
import { FaUserAstronaut } from "react-icons/fa";
import { FiLogOut, FiUser } from "react-icons/fi";

import useAuth from "@/hooks/useAuth";
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from "../ui/menu";

const UserMenu = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    logout();
  };

  return (
    <>
      {/* Desktop */}
      <Flex>
        <MenuRoot>
          <MenuTrigger asChild p={2}>
            <Button
              data-testid="user-menu"
              variant="solid"
              maxW="150px"
              truncate
            >
              <FaUserAstronaut fontSize="18px" />
              <Text>{user?.full_name || "사용자"}</Text>
            </Button>
          </MenuTrigger>

          <MenuContent>
            <Link to="settings">
              <MenuItem
                closeOnSelect
                value="user-settings"
                gap={2}
                py={2}
                style={{ cursor: "pointer" }}
              >
                <FiUser fontSize="18px" />
                <Box flex="1">내 프로필</Box>
              </MenuItem>
            </Link>

            <MenuItem
              value="logout"
              gap={2}
              py={2}
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              <FiLogOut />
              로그아웃
            </MenuItem>
          </MenuContent>
        </MenuRoot>
      </Flex>
    </>
  );
};

export default UserMenu;
